
import lazyload from "@/directives/lazyload";
import phone from "@/assets/images/landing/svg/phone-red.svg";
import question from "@/assets/images/landing/svg/question-red.svg";
import man from "@/assets/images/landing/svg/man-red.svg";
import phoneAnim from "@/assets/images/landing/img/phone-anim.png";
export default {
  data() {
    return {
      images: {
        phoneAnim,
      },
      list: [
        {
          image: phone,
          title:
            '<h3>we catch <span class="span--text-red">infidelity online</span></h3>',
          text:
            'iFindCheaters is the only online service using' +
            ' advanced search technology to help you catch cheaters. If an account exists, we will find it.' +
            ' Within minutes view your partner’s online XXX Websites presence, so you can monitor their activity and protect yourself.',
        },
        {
          image: question,
          title: '<h3>how <span class="span--text-red">we find</span> them</h3>',
          text:
            'By directly accessing popular XXX Websites, we can detect active profiles that your partner maintains. We provide you that information so you can follow up and really know who you are involved with.',
        },
        {
          image: man,
          title: '<h3>100% <span class="span--text-red">anonymous</span> service</h3>',
          text:
            'iFindCheaters enables you to discover if your partner may be cheating without revealing your identity. We respect your privacy. iFindCheaters searches are 100% confidential – we will never disclose your user information or alert your partner.',
        },
      ],
    };
  },
  methods: {
    onClickBlock(e) {
      console.dir(e);
      var options = document.querySelectorAll(".description-list__item");
      var parentEl = e.target.offsetParent;
      options.forEach(function (el) {
        el.classList.remove("active");
      });
      if (parentEl.className === "description-list__item") {
        parentEl.classList.add("active");
      } else if (e.target.className === "description-list__item") {
        e.target.classList.add("active");
      }
    },
  },
  directives: {
    lazyload,
  },
};
